import CustomControl from './CustomControl';

export default CustomControl;
